module.exports = __webpack_public_path__ + "static/media/image-7.7fa6ee0f.jpg";